var $ = global.jQuery = global.$;
require('../third-party/slick');

var utils = require('../lib/utils');
var _debounce = require('lodash/function/debounce');

var slickDefaults = {
  autoplay: true,
  autoplaySpeed: 9000,
  speed: 450,
  easing: 'swing',
  dots: false,
  infinite: true,
  arrows: true,
  swipe: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg-defs-sprite.svg#arrow-thin"></use></svg><span class="a11y">Previous</span></button>',
  nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg-defs-sprite.svg#arrow-thin"></use></svg><span class="a11y">Next</span></button>',
  responsive: [{
    breakpoint: 767,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 1199,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  }]
};

var counterTemplate = function(currentPage, totalPages) {
  return currentPage + '/' + totalPages;
};

var Equalise = require('./Equalise');

/**
 * Slider widget that implements Slick slider with some default options
 * @class
 * @extends Equalise
 */
var Slider = Equalise.extend(
  /** @lends Slider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.$el.data('equaliseTargets', '[data-slides]');

    //Then call the Equalise widgets own init method
    this._super();

    this._debouncedSliderResizeHandler = _debounce(this._sliderResizeHandler, 600);

    this.newOpts = this.widgetOptions;
    this.$sliderCounter = this.$el.find('[data-slides-counter]');
    this.$slides = this.$el.find('[data-slides]');
    this.$prevArrow = this.$el.find('[data-arrow-prev]');
    this.$nextArrow = this.$el.find('[data-arrow-next]');

    for (var opt in slickDefaults) {
      if (slickDefaults.hasOwnProperty(opt)) {
        this.newOpts[opt] = this.widgetOptions[opt] || this.widgetOptions[opt] === false ? this.widgetOptions[opt] : slickDefaults[opt];
      }
    }

    this.newOpts.appendArrows = this.$el;
    this.newOpts.prevArrow = this.$prevArrow.length > 0 ? this.$prevArrow : this.newOpts.prevArrow;
    this.newOpts.nextArrow = this.$nextArrow.length > 0 ? this.$nextArrow : this.newOpts.nextArrow;

    if (this.$sliderCounter.length > 0) {
      this.$slides.on('init afterChange', function(event, slick) {
        setTimeout(function() {
          var visibleItems = slick.activeBreakpoint ? slick.breakpointSettings[slick.activeBreakpoint].slidesToScroll : 1;
          var totalPages = Math.ceil(slick.slideCount / visibleItems);
          var currentPage = (slick.currentSlide / visibleItems) + 1;
          self.updateCounter(currentPage, totalPages, slick);
        }, 100);
      });
    }

    this.$slides.on('init setPosition', this._debouncedSliderResizeHandler.bind(this));

    this.$slides.slick(this.newOpts);

  },
  /**
   * Resize handler
   * @private
   */
  _resizeHandler: function() {
    if (utils.getWindow().width !== this.w){
      this.redraw();
    }
  },
  _sliderResizeHandler: function() {
    this.equalise();
    this.w = utils.getWindow().width;
  },
  /**
   * Redraws the Slider
   */
  redraw: function() {
    this.$slides.slick('setPosition');
    this.$slides.slick('slickGoTo', 1);
  },
  /**
   * Updates the Slider counter (if there is one)
   */
  updateCounter: function(currentPage, totalPages) {
    this.$sliderCounter.html(counterTemplate(currentPage, totalPages));
  }
});

module.exports = Slider;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Slider.js
 ** module id = 33
 ** module chunks = 0 1
 **/